export const WORDS = ['chair']
